<template>
  <div class="paginationPerPage">
    <div class="pages">
      <div v-if="perPage" class="pages__item">
        <span class="pages__item--text">{{
          $t('shared.pagination.items_text')
        }}</span>
        <Select class="pages__item--pagination">
          <SelectSelection :value="perPage" @input-change="changePerPage">
            <SelectOption
              v-for="perPageOption in perPageOptions"
              :key="perPageOption"
              :value="perPageOption"
            >
              <span>{{ perPageOption }}</span>
            </SelectOption>
          </SelectSelection>
        </Select>
      </div>
      <div class="pages__item">
        <span class="pages__item--text">{{
          $t('shared.pagination.page_text')
        }}</span>
        <Select class="pages__item--pagination">
          <SelectSelection
            :value="selectedPage"
            @input-change="$emit('onChange', $event)"
          >
            <SelectOption v-for="page in pageRange" :key="page" :value="page">
              <span>{{ page }}</span>
            </SelectOption>
          </SelectSelection>
        </Select>
        <div class="pages__btns">
          <button
            class="page__btn"
            :disabled="disabledDecrease"
            @click="onChange(-1)"
          >
            <i class="fas fa-chevron-left" />
          </button>
          <button
            class="page__btn"
            :disabled="disabledIncrease"
            @click="onChange(1)"
          >
            <i class="fas fa-chevron-right" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import Select from '@/components/shared/select/Select'
import SelectOption from '@/components/shared/select/SelectOption'
import SelectSelection from '@/components/shared/select/SelectSelection'
import i18n from '@/i18n'
import { computed, defineProps, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const $t = i18n.t

const emit = defineEmits(['onChange', 'changePerPage'])

const props = defineProps({
  currentPage: Number,
  totalPages: Number,
  perPage: Number
})

const pageRange = ref([])
const perPageOptions = ref([15, 25, 50, 100])
const selectedPage = ref(1)

const disabledDecrease = computed(() => {
  if (selectedPage.value > 1) return false
  return true
})
const disabledIncrease = computed(() => {
  if (selectedPage.value < props.totalPages) return false
  return true
})

watch(
  () => props.totalPages,
  (newVal) => {
    pageRange.value = range(1, newVal)
  },
  { immediate: true }
)
watch(
  () => props.currentPage,
  () => {
    selectedPage.value = props.currentPage
  }
)
watch(
  () => route.query.page,
  (page) => {
    if (page) {
      selectedPage.value = page
    } else {
      selectedPage.value = props.currentPage
    }
  },
  { immediate: true }
)

function range(min, max) {
  return [...Array(max - min + 1).keys()].map((i) => i + min)
}

function onChange(num) {
  const pageNum = num + props.currentPage
  emit('onChange', pageNum)
}

function changePerPage(value) {
  emit('changePerPage', Number(value))
}
</script>
<style lang="scss">
.paginationPerPage {
  margin-top: auto;
  background: $blue-10;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  .pages {
    color: #454a5b;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 60px;
    &__item {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      &:first-child {
        margin-bottom: 1rem;
      }
      &--text {
        font-size: 12px;
        padding: 0 10px;
        display: block;
      }
      &--pagination {
        font-size: 14px;
      }
    }
    &__btns {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-left: 10px;
    }
    .page__btn {
      background: $white;
      border: 1px solid $black-10;
      cursor: pointer;
      border-radius: var(--border-radius);
      padding: 10px;
      height: 100%;
      &:hover {
        background: $black-10;
      }
      &:nth-child(1) {
        margin-right: 5px;
      }
      &[disabled] {
        cursor: not-allowed;
        &:hover {
          background: $white;
        }
      }
    }
  }
  @include mobileLandscape {
    .pages {
      flex-direction: row;
      align-items: center;
      &__item {
        &--text {
          font-size: 14px;
          padding: 0 25px;
        }
        &:first-child {
          margin-bottom: 0;
        }
      }
      &__btns {
        padding-left: 20px;
      }
    }
  }
}
</style>
